module.exports = __webpack_public_path__ + "static/media/R-330XLHD_CrossSection.5e78b0aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/en/R-330XLHD_CrossSection.png
// module id = 479
// module chunks = 0